<template>
  <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
      <li :class="{ topmenuactive: activeTab === 'hethongcnttbacninh' }" @click="changeTab('hethongcnttbacninh')">
        <a id="urlhethongcnttbacninh" href="vi/chuongtrinhtaitroxathidiem#bacninh/hethongcnttbacninh" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xayentrung' } " @click="changeTab('Xayentrung')">
        <a id="urlXayentrung" href="vi/chuongtrinhtaitroxathidiem#bacninh/xayentrung" style="color: white;">Yên Trung</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xayenphong' }" @click="changeTab('Xayenphong')"  >
        <a id="urlXayenphong" href="vi/chuongtrinhtaitroxathidiem#bacninh/xayenphong" style="color: white;">Yên Phong</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xahiephoa' }" @click="changeTab('Xahiephoa')">
        <a id="urlXahiephoa" href="vi/chuongtrinhtaitroxathidiem#bacninh/xahiephoa" style="color: white;">Hiệp Hòa</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xahopthinh' }" @click="changeTab('Xahopthinh')" >
        <a id="urlXahopthinh" href="vi/chuongtrinhtaitroxathidiem#bacninh/xahopthinh" style="color: white;">Hợp Thịnh</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaxuancam' }" @click="changeTab('Xaxuancam')" >
        <a id="urlXaxuancam" href="vi/chuongtrinhtaitroxathidiem#bacninh/xaxuancam" style="color: white;">Xuân Cẩm</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xahoangvan' }" @click="changeTab('Xahoangvan')" >
        <a id="urlXahoangvan" href="vi/chuongtrinhtaitroxathidiem#bacninh/xahoangvan" style="color: white;">Hoàng Vân</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xatiendu' }" @click="changeTab('Xatiendu')" >
        <a id="urlXatiendu" href="vi/chuongtrinhtaitroxathidiem#bacninh/xatiendu" style="color: white;">Tiên Du</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xadaidong' }" @click="changeTab('Xadaidong')"  >
        <a id="urlXadaidong" href="vi/chuongtrinhtaitroxathidiem#bacninh/xadaidong" style="color: white;">Đại Đồng</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaphattich' }" @click="changeTab('Xaphattich')" >
        <a id="urlXaphattich" href="vi/chuongtrinhtaitroxathidiem#bacninh/xaphattich" style="color: white;">Phật Tích</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xalienbao' }" @click="changeTab('Xalienbao')" >
        <a id="urlXalienbao" href="vi/chuongtrinhtaitroxathidiem#bacninh/xalienbao" style="color: white;">Liên Bão</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xatanchi' }" @click="changeTab('Xatanchi')" >
        <a id="urlXatanchi" href="vi/chuongtrinhtaitroxathidiem#bacninh/xatanchi" style="color: white;">Tân Chi</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xachilang' }" @click="changeTab('Xachilang')" >
        <a id="urlXachilang" href="vi/chuongtrinhtaitroxathidiem#bacninh/xachilang" style="color: white;">Chi Lăng</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xadongcuu' }" @click="changeTab('Xadongcuu')" >
        <a id="urlXadongcuu" href="vi/chuongtrinhtaitroxathidiem#bacninh/xadongcuu" style="color: white;">Đông Cứu</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xagiabinh' }" @click="changeTab('Xagiabinh')" >
        <a id="urlXagiabinh" href="vi/chuongtrinhtaitroxathidiem#bacninh/xagiabinh" style="color: white;">Gia Bình</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xatamda' }" @click="changeTab('Xatamda')"  > 
        <a id="urlXatamda" href="vi/chuongtrinhtaitroxathidiem#bacninh/xatamda" style="color: white;">Tam Đa</a>
      </li>
    </ul>
  </nav>

  <div class="wrapper row3">

    <main class="hoc container-fluid clear bv p-0">
      <!-- Mỗi xã -->
      <div v-if="activeTab === 'hethongcnttbacninh'" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHtmlHethongcnttbacninh"></div>
        <div v-html="contentHtmlHethongcnttbacninh || 'Đang cập nhật...'"></div>
        </div>
      <div v-if="showXayentrung" class="padding-top15"><strong>Yên Trung</strong><div v-html="contentHtmlXayentrung || 'Đang cập nhật...'"></div></div>
      <div v-if="showXayenphong" class="padding-top15"><strong>Yên Phong</strong><div v-html="contentHtmlXayenphong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXahiephoa" class="padding-top15"><strong>Hiệp Hòa</strong><div v-html="contentHtmlXahiephoa || 'Đang cập nhật...'"></div></div>
      <div v-if="showXahopthinh" class="padding-top15"><strong>Hợp Thịnh</strong><div v-html="contentHtmlXahopthinh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaxuancam" class="padding-top15"><strong>Xuân Cẩn</strong><div v-html="contentHtmlXaxuancam || 'Đang cập nhật...'"></div></div>
      <div v-if="showXahoangvan" class="padding-top15"><strong>Hoàng Vân</strong><div v-html="contentHtmlXahoangvan || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatiendu" class="padding-top15"><strong>Tiên Du</strong><div v-html="contentHtmlXatiendu || 'Đang cập nhật...'"></div></div>      
      <div v-if="showXadaidong" class="padding-top15"><strong>Đại Đồng</strong><div v-html="contentHtmlXadaidong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaphattich" class="padding-top15"><strong>Phật Tích</strong><div v-html="contentHtmlXaphattich || 'Đang cập nhật...'"></div></div>
      <div v-if="showXalienbao" class="padding-top15"><strong>Liên Bảo</strong><div v-html="contentHtmlXalienbao || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatanchi" class="padding-top15"><strong>Tân Chi</strong><div v-html="contentHtmlXatanchi || 'Đang cập nhật...'"></div></div>
      <div v-if="showXachilang" class="padding-top15"><strong>Chi Lăng</strong><div v-html="contentHtmlXachilang || 'Đang cập nhật...'"></div></div>
      <div v-if="showXadongcuu" class="padding-top15"><strong>Đông Cứu</strong><div v-html="contentHtmlXadongcuu || 'Đang cập nhật...'"></div></div>
      <div v-if="showXagiabinh" class="padding-top15"><strong>Gia Bình</strong><div v-html="contentHtmlXagiabinh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatamda" class="padding-top15"><strong>Tam Đa</strong><div v-html="contentHtmlXatamda || 'Đang cập nhật...'"></div></div>
    </main>
  </div>
</template>
<script scoped>
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";


export default {
  components: {

  },
  data() {
    return {
      activeTab: 'hethongcnttbacninh',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showXahiephoa: false,
      showXahopthinh: false,
      showXayenphong: false,
      showCopilot: false,
      showGrok: false,
      showXaxuancam: false,
      showManus: false,
      showXayentrung: false,
      showXahoangvan: false,
      showXatiendu: false,
      showUngDungAI: false,
      showXatamda: false,
      showXadaidong: false,
      showXaphattich: false,
      showXalienbao: false,
      showXatanchi: false,
      showXachilang: false,
      showXadongcuu: false,
      showXagiabinh: false,
      showHethongcnttbacninh: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlXayentrung: "",
      titleHtmlXahiephoa: "",
      titleHtmlXahopthinh: "",
      titleHtmlXayenphong: "",
      titleHtmlCopilot: "",
      titleHtmlGrok: "",
      titleHtmlXaxuancam: "",
      titleHtmlXahoangvan: "",
      titleHtmlXatiendu: "",
      titleHtmlManus: "",
      titleHtmlUngDungAI: "",
      titleHtmlXatamda: "",
      titleHtmlXadaidong: "",
      titleHtmlXaphattich: "",
      titleHtmlXalienbao: "",
      titleHtmlXatanchi: "",
      titleHtmlXachilang: "",
      titleHtmlXadongcuu: "",
      titleHtmlXagiabinh: "",
titleHtmlHethongcnttbacninh: "",
conttentHtmlHethongcnttbacninh: "",

      contentHtmlXayentrung: "",
      contentHtmlXahiephoa: "",
      contentHtmlXahopthinh: "",
      contentHtmlCopilot: "",
      contentHtmlXayenphong: "",
      contentHtmlGrok: "",
      contentHtmlXaxuancam: "",
      contentHtmlXahoangvan: "",
      contentHtmlXatiendu: "",
      contentHtmlManus: "",
      contentHtmlUngDungAI: "",
      contentHtmlXatamda: "",

      contentHtmlXadaidong: "",
      contentHtmlXaphattich: "",
      contentHtmlXalienbao: "",
      contentHtmlXatanchi: "",
      contentHtmlXachilang: "",
      contentHtmlXadongcuu: "",
      contentHtmlXagiabinh: "",


    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages")   || "vi";
      // this.performPostRequest("1755075075179y5bWE", "Xahiephoa", this.lang);
document.getElementById("urlhethongcnttbacninh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/hethongcntt");
      document.getElementById("urlXayentrung").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xayentrung");
      document.getElementById("urlXayenphong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xayenphong");
      document.getElementById("urlXahopthinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xahopthinh");
      document.getElementById("urlXahiephoa").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xahiephoa");
      document.getElementById("urlXaxuancam").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xaxuancam");
      document.getElementById("urlXahoangvan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xahoangvan");
      document.getElementById("urlXatiendu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xatiendu");
      document.getElementById("urlXatamda").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xatamda");
      document.getElementById("urlXadaidong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xadaidong");
      document.getElementById("urlXaphattich").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xaphattich");
      document.getElementById("urlXalienbao").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xalienbao");
      document.getElementById("urlXatanchi").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xatanchi");
      document.getElementById("urlXachilang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xachilang");
      document.getElementById("urlXadongcuu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xadongcuu");
      document.getElementById("urlXagiabinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/xagiabinh");


      // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/manus/");
      // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/grok/");
      // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#bacninh/copilot/");




      let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
      // console.log("fragmentTab " + fragmentTab);

      if (fragmentTab === "bacninh/xayentrung") {
        this.changeTab("Xayentrung");
      } else if (fragmentTab === "bacninh/xayenphong") {
        this.changeTab("Xayenphong");
      } else if (fragmentTab === "bacninh/xahopthinh") {
        this.changeTab("Xahopthinh");
      } else if (fragmentTab === "bacninh/xahiephoa") {
        this.changeTab("Xahiephoa");
      } else if (fragmentTab === "bacninh/copilot") {
        this.changeTab("Copilot");
      } else if (fragmentTab === "bacninh/grok") {
        this.changeTab("Grok");
      } else if (fragmentTab === "bacninh/xaxuancam") {
        this.changeTab("Xaxuancam");
      } else if (fragmentTab === "bacninh/manus") {
        this.changeTab("Manus");
      } else if (fragmentTab === "bacninh/xahoangvan") {
        this.changeTab("Xahoangvan");
      }   else if (fragmentTab === "bacninh/xatiendu") {
        this.changeTab("Xatiendu");
      } else if (fragmentTab === "bacninh/xatamda") {
        this.changeTab("Xatamda");
      } else if (fragmentTab === "bacninh/xadaidong") {
        this.changeTab("Xadaidong");
      } else if (fragmentTab === "bacninh/xaphattich") {
        this.changeTab("Xaphattich");
      } else if (fragmentTab === "bacninh/xalienbao") {
        this.changeTab("Xalienbao");
      } else if (fragmentTab === "bacninh/xatanchi") {
        this.changeTab("Xatanchi");
      } else if (fragmentTab === "bacninh/xachilang") {
        this.changeTab("Xachilang");
      } else if (fragmentTab === "bacninh/xadongcuu") {
        this.changeTab("Xadongcuu");
      } else if (fragmentTab === "bacninh/xagiabinh") {
        this.changeTab("Xagiabinh");
      }
else if (fragmentTab === "bacninh/hethongcnttbacninh") {
        this.changeTab("hethongcnttbacninh");
}
       else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("hethongcnttbacninh");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
        if (section === "Xahiephoa") {
          this.titleHtmlXahiephoa = decodeURIComponent(escape(title));
          this.contentHtmlXahiephoa = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahopthinh") {
          this.titleHtmlXahopthinh = decodeURIComponent(escape(title));
          this.contentHtmlXahopthinh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xayenphong") {
          this.titleHtmlXayenphong = decodeURIComponent(escape(title));
          this.contentHtmlXayenphong = decodeURIComponent(escape(decodedString));
        } else if (section === "Copilot") {
          this.titleHtmlCopilot = decodeURIComponent(escape(title));
          this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
        } else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaxuancam") {
          this.titleHtmlXaxuancam = decodeURIComponent(escape(title));
          this.contentHtmlXaxuancam = decodeURIComponent(escape(decodedString));
        } else if (section === "Manus") {
          this.titleHtmlManus = decodeURIComponent(escape(title));
          this.contentHtmlManus = decodeURIComponent(escape(decodedString));
        } else if (section === "Xayentrung") {
          this.titleHtmlXayentrung = decodeURIComponent(escape(title));
          this.contentHtmlXayentrung = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xahoangvan") {
          this.titleHtmlXahoangvan = decodeURIComponent(escape(title));
          this.contentHtmlXahoangvan = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xatiendu") {
          this.titleHtmlXatiendu = decodeURIComponent(escape(title));
          this.contentHtmlXatiendu = decodeURIComponent(escape(decodedString));
        }else if (section === "UngDungAI") {
          this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
          this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
        } else if (section === "Xatamda") {
          this.titleHtmlXatamda = decodeURIComponent(escape(title));
          this.contentHtmlXatamda = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadaidong") {
          this.titleHtmlXadaidong = decodeURIComponent(escape(title));
          this.contentHtmlXadaidong = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphattich") {
          this.titleHtmlXaphattich = decodeURIComponent(escape(title));
          this.contentHtmlXaphattich = decodeURIComponent(escape(decodedString));
        } else if (section === "Xalienbao") {
          this.titleHtmlXalienbao = decodeURIComponent(escape(title));
          this.contentHtmlXalienbao = decodeURIComponent(escape(decodedString));
        } else if (section === "Xatanchi") {
          this.titleHtmlXatanchi = decodeURIComponent(escape(title));
          this.contentHtmlXatanchi = decodeURIComponent(escape(decodedString));
        } else if (section === "Xachilang") {
          this.titleHtmlXachilang = decodeURIComponent(escape(title));
          this.contentHtmlXachilang = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadongcuu") {
          this.titleHtmlXadongcuu = decodeURIComponent(escape(title));
          this.contentHtmlXadongcuu = decodeURIComponent(escape(decodedString));
        } else if (section === "Xagiabinh") {
          this.titleHtmlXagiabinh = decodeURIComponent(escape(title));
          this.contentHtmlXagiabinh = decodeURIComponent(escape(decodedString));
        }else if (section === "hethongcnttbacninh") {
          this.titleHtmlHethongcnttbacninh = decodeURIComponent(escape(title));
          this.contentHtmlHethongcnttbacninh = decodeURIComponent(escape(decodedString));
       
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      //   if (window.innerWidth <= 768) {
      //     this.isMenuVisible = false;
      //   }
      this.lang = localStorage.getItem("languages");

      const tabStates = {

        Xahiephoa: false, Xahopthinh: false, Xayenphong: false, Copilot: false, ungDungAI: false,
        Xayentrung: false, xaxuancam: false, Grok: false, Manus: false, Xahoangvan: false, Xatiendu: false,
        Xatamda: false, Xadaidong: false, Xaphattich: false, Xalienbao: false, Xatanchi: false, Xachilang: false, Xadongcuu: false, Xagiabinh: false,
        hethongcnttbacninh: false,
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showXahiephoa = tabStates.Xahiephoa;
      this.showXahopthinh = tabStates.Xahopthinh;
      this.showXayenphong = tabStates.Xayenphong;
      this.showCopilot = tabStates.Copilot;
      this.showGrok = tabStates.Grok;
      this.showXaxuancam = tabStates.Xaxuancam;
      this.showManus = tabStates.Manus;
      this.showXayentrung = tabStates.Xayentrung;
      this.showXahoangvan = tabStates.Xahoangvan;
      this.showXatiendu = tabStates.Xatiendu;
      this.showUngDungAI = tabStates.UngDungAI;
      this.showXatamda = tabStates.Xatamda;
      this.showXadaidong = tabStates.Xadaidong;
      this.showXaphattich = tabStates.Xaphattich;
      this.showXalienbao = tabStates.Xalienbao;
      this.showXatanchi = tabStates.Xatanchi;
      this.showXachilang = tabStates.Xachilang;
      this.showXadongcuu = tabStates.Xadongcuu;

      this.showXagiabinh = tabStates.Xagiabinh;
      this.showHethongcnttbacninh = tabStates.hethongcnttbacninh;

    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {

        Xahiephoa: "",
        Xahopthinh: "",
        Xayenphong: "",
        Copilot: "",
        Grok: "",
        Xaxuancam: "",
        Manus: "",
        Xayentrung: "",
        Xahoangvan: "", 
        Xatiendu: "",        
        UngDungAI: "",   
        Xatamda: "",   
        Xadaidong: "", 
        Xaphattich: "", 
        Xalienbao: "", 
        Xatanchi: "",    
        Xachilang: "",     
        Xadongcuu: "",   
        Xagiabinh: "",    
        hethongcnttbacninh: "17582699256672sJlt", 
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.title-bai-viet {
  display: none;
}

.hiddentitle {
  display: none;
}
</style>
